import { __awaiter, __generator } from "tslib";
import deepmerge from 'deepmerge';
var AnalyticsContext = (function () {
    function AnalyticsContext(Scopes, ExtraData, MetaData, Identities, Filters) {
        if (Scopes === void 0) { Scopes = []; }
        if (ExtraData === void 0) { ExtraData = {}; }
        if (MetaData === void 0) { MetaData = {}; }
        if (Identities === void 0) { Identities = {}; }
        if (Filters === void 0) { Filters = []; }
        this.Scopes = Scopes;
        this.ExtraData = ExtraData;
        this.MetaData = MetaData;
        this.Identities = Identities;
        this.Filters = Filters;
    }
    AnalyticsContext.prototype.union = function (analyticsContext) {
        if (!analyticsContext) {
            return this;
        }
        return new AnalyticsContext(this.Scopes.concat(analyticsContext.Scopes || []), deepmerge(this.ExtraData, analyticsContext.ExtraData || {}), deepmerge(this.MetaData, analyticsContext.MetaData || {}), deepmerge(this.Identities, analyticsContext.Identities || {}), this.Filters.concat(analyticsContext.Filters || []));
    };
    AnalyticsContext.prototype.toEventModel = function (eventName) {
        return __awaiter(this, void 0, void 0, function () {
            var eventModel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventModel = {
                            Name: eventName,
                            Scope: this.Scopes.join('_'),
                            ExtraData: deepmerge({}, this.ExtraData),
                            MetaData: deepmerge({}, this.MetaData),
                            Identities: deepmerge({}, this.Identities),
                        };
                        return [4, this.Filters.reduce(function (acc, filter) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, acc];
                                        case 1:
                                            _a.sent();
                                            return [4, filter(eventModel)];
                                        case 2:
                                            _a.sent();
                                            return [2];
                                    }
                                });
                            }); }, Promise.resolve())];
                    case 1:
                        _a.sent();
                        return [2, eventModel];
                }
            });
        });
    };
    return AnalyticsContext;
}());
export { AnalyticsContext };
//# sourceMappingURL=AnalyticsContext.js.map